export * from '@lexical/react/LexicalTablePlugin'
